<script>
	import { fade } from 'svelte/transition';

	let age = 43;
	let ast = 20;
	let pt = 166;
	let alt = 16;
	$: result = ((age*ast)/(pt*Math.sqrt(alt))).toFixed(2);

	let visible = false;

	function show(){
		visible = true;
	}

	const scriptURL = 'https://script.google.com/macros/s/AKfycbxhViTjQZOl4M5cEP89h-oeEsNCwfTj_7VgZflFqq1SbRUNjzCqiMz6Q_BiVWMlBh_x/exec'

	function submit(e){
		e.preventDefault()
		fetch(scriptURL, { method: 'POST', body: new FormData(this)})
				.then(response => console.log('Success!', response))
				.catch(error => console.error('Error!', error.message))
	}

</script>

<div class="flex row center m-auto">

	<div class="p-2">FIB-4 =</div>

	<div class="flex column">

		<div class="flex">
			<div class="p-2"><label for="age">Godine starosti</label><input type="number" min="20" max="99" bind:value={age}/></div>
			<div class="p-2">x</div>
			<div class="p-2"><label for="ast">Vrijednost AST <em>(U/l)</em></label><input type="number" min="1" bind:value={ast}/></div>
		</div>

		<hr class="hr">

		<div class="flex">
			<div class="p-2"><label for="pt">Broj trombocita (10<sup>9</sup>/l)</label><input type="number" min="1" bind:value={pt}/></div>
			<div class="p-2">x</div>
			<div class="p-2"><label for="alt">&radic; Vrijednost ALT <em>(U/l)</em></label><input type="number" min="1" bind:value={alt}/></div>
		</div>

	</div>

	<div class="p-2 text-lg">={result}</div>

</div>

<div class="mb-6 m-auto text-center">
	<form on:submit={submit} name="submit-to-google-sheet">
		<input name="result" hidden value={result}>
		<button on:click={show} type="submit">Izračunaj</button>
	</form>
</div>

{#if visible}
	<div transition:fade>
		{#if result <= 1.29}
			<div class="notification"><span>{result}</span> Nizak rizik za uznapredovalu fibrozu jetre</div>
		{:else if 1.30 <= result && result < 2.67 }
			<div class="notification"><span>{result}</span> Umjeren rizik za uznapredovalu fibrozu jetre (potrebni dodatni testovi)</div>
		{:else}
			<div class="notification"><span>{result}</span> Visok rizik za uznapredovalu fibrozu jetre i druge poremećaje jetre</div>
		{/if}
	</div>
{/if}


<style>
	.text-center {
		text-align: center;
	}
	.m-auto {
		margin: 0 auto;
	}
	.mb-6{
		margin-bottom: 1rem;
	}
	.center{
		justify-content: center !important;
		align-items:center !important;
	}
	.notification {
		padding: 1rem;
		background-color: #02534C1F;
		border-style: solid;
		border-width: 1px;
		border-color: var( --e-global-color-primary );
		border-radius: 5px;
		display:flex;
		justify-content: start;
		align-items: center;
		gap: 12px;
	}
	.notification span {
		font-size: 2em;
	}
	.hr{
		width:100%;
	}
	.flex {
		display:flex;
		align-items:center;
		padding: .5rem;
	}
	.text-lg {
		font-size:2em;
	}
	label {
		font-size: .75rem;
		display: block;
		margin-bottom: .25rem;
	}
	input{
		width: 140px !important;
		font-size: 1rem;
	}
	.p-2{
		padding:.2rem
	}

	@media screen and (max-width:576px){
		.row {
			flex-direction:column;
		}
	}
	.row{
		flex-direction:row;
	}
	.column {
		flex-direction:column;
	}
</style>
